import React, {FC} from "react";
import {ReportItemsSearchPanel, ReportPage} from "../../../components";
import {getPageNameByPageId, getUserId} from "../../../utils";
import {ItemReportSearchParamsModel, PageEnum} from "../../../models";
import {searchReportBestLeastSellingItems} from "../../../serviceBroker/itemsReportApiServiceBroker";

export const ReportBestLeastSellingItemsPage: FC = () => {
    const initialState: ItemReportSearchParamsModel = {Lang: 1, userId: getUserId()};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportBestLeastSellingItems}
            searchHeader={getPageNameByPageId(PageEnum.ReportBestAndLeastSellingItems)}
            SearchPanel={ReportItemsSearchPanel}
            withDateRange={true}
            reportType={true}
            formId={PageEnum.ReportBestAndLeastSellingItems}
        />
    );
};
